import FooterWrapper, { List, ListItem } from './footer.style';

import Box from 'common/src/components/Box';
import Container from 'common/src/components/UI/Container';
import CookieConsent from "react-cookie-consent";
import Heading from 'common/src/components/Heading';
import Image from 'common/src/components/Image';
import { LanguageContext } from 'common/src/contexts/LanguageContext';
import Logo from 'common/src/components/UIElements/Logo';
import LogoImage from 'common/src/assets/image/lang4u/lang4ulogo-alt.png';
import PropTypes from 'prop-types';
import React from 'react';
import Text from 'common/src/components/Text';
import VisaImage from 'common/src/assets/image/lang4u/visa-fondy.svg';
import { useFooterMenuItems } from '../../../utils/useFooterMenuItems';

const Footer = ({
  row,
  col,
  colOne,
  colTwo,
  titleStyle,
  logoStyle,
  textStyle,
  visaLogoStyle,
  sslSecured,
}) => {

  const widgets = useFooterMenuItems()
  const { lang } = React.useContext(LanguageContext)

  const consentText = lang === 'en' ? (
    'This website uses cookies to enhance the user experience.'
  ) : (
    'Этот веб-сайт использует cookie для улучшения качества предоставляемых услуг.'
  )

  const consentAcceptText = lang === 'en' ? (
    'Accept'
  ) : (
    'Принять'
  )

  return (
    <FooterWrapper>
      <Container className="footer_container">
        <Box className="row" {...row}>
          <Box {...colOne}>
            <Logo
              href="#"
              logoSrc={LogoImage}
              title="Lan4U"
              logoStyle={logoStyle}
            />
            <Text content="hello@lang4u.eu" {...textStyle} />
            <Text content="© Lang4U 2017-2023" {...textStyle} style={{fontSize: '.9em'}} />
            <Image src={VisaImage} alt="Visa/MasterCard/Fondy" {...visaLogoStyle} />
            <Text content="SSL Secured" {...sslSecured} style={{fontStyle: 'italic'}} />
          </Box>
          {/* End of footer logo column */}
          <Box {...colTwo}>
            {widgets.map((widget, index) => (
              <Box className="col" {...col} key={`footer-widget-${index}`}>
                <Heading content={widget.title} {...titleStyle} />
                <List>
                  {widget.menuItems.map((item, index) => (
                    <ListItem key={`footer-list-item-${index}`}>
                      <a href={item.url} className="ListItem">
                        {item.text}
                      </a>
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </Box>
          {/* End of footer List column */}
        </Box>
      </Container>

      <CookieConsent
        location="bottom"
        buttonText={consentAcceptText}
        cookieName="lang4uCookieAccepted"
        style={{ background: "rgb(66,108,180)", borderTop: '3px solid #edcd37' }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
        sameSite="strict"
      >
        {consentText}
      </CookieConsent>
    </FooterWrapper>
  );
};

// Footer style props
Footer.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  colOne: PropTypes.object,
  colTwo: PropTypes.object,
  titleStyle: PropTypes.object,
  textStyle: PropTypes.object,
  logoStyle: PropTypes.object,
};

// Footer default style
Footer.defaultProps = {
  // Footer row default style
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
  },
  // Footer col one style
  colOne: {
    width: [1, '35%', '35%', '30%'],
    mt: [0, '13px'],
    mb: ['30px', 0],
    pl: ['15px', 0],
    pr: ['15px', '15px', 0],
  },
  // Footer col two style
  colTwo: {
    width: ['100%', '65%', '65%', '70%'],
    flexBox: true,
    flexWrap: 'wrap',
  },
  // Footer col default style
  col: {
    width: ['100%', '50%', '50%', '33%'],
    pl: '15px',
    pr: '15px',
    mb: '30px',
  },
  // widget title default style
  titleStyle: {
    color: '#343d48',
    fontSize: '16px',
    fontWeight: '700',
    mb: '30px',
  },
  // Default logo size
  logoStyle: {
    width: '90px',
    mb: '15px',
  },
  // widget text default style
  textStyle: {
    color: '#0f2137',
    fontSize: '16px',
    mb: '10px',
  },
  visaLogoStyle: {
    width: '220px',
    mt: '25px',
  },
  sslSecured: {
    color: 'rgb(52, 61, 72)',
    fontSize: '.8em',
    mt: '18px',
  },
};

export default Footer;
